/**
 * Builds table of contents from h2 headings in learn article body.
 */
(function () {
  const tocList = document.querySelector('[data-shinzo-article-toc]');
  const body = document.querySelector('.shinzo-article__body');
  if (!tocList || !body) return;

  const headings = body.querySelectorAll('h2[id]');
  if (!headings.length) {
    const tocNav = tocList.closest('.shinzo-article__toc');
    if (tocNav) tocNav.hidden = true;
    return;
  }

  const fragment = document.createDocumentFragment();
  headings.forEach((heading) => {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${heading.id}`;
    a.textContent = heading.textContent.trim();
    li.appendChild(a);
    fragment.appendChild(li);
  });

  tocList.appendChild(fragment);
})();
